import { useEffect } from "react";
import { BUSINESS } from "@/data/site";

const OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/63540915-4713-49ff-8264-568b5b916c56/images/899df527802ba753eaf69c5e166cef45ec3f0f13ffe59ce0ff90c41646ca9e13.jpeg";

function upsertMeta(name, content, attr = "name") {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function Seo({ title, description, jsonLd, breadcrumbs }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | ${BUSINESS.name}`
      : `${BUSINESS.name} | DFW's Trusted Sitter Agency Since ${BUSINESS.established}`;
    document.title = fullTitle;
    if (description) {
      upsertMeta("description", description);
      upsertMeta("og:title", fullTitle, "property");
      upsertMeta("og:description", description, "property");
      upsertMeta("twitter:title", fullTitle);
      upsertMeta("twitter:description", description);
    }
    upsertMeta("og:image", OG_IMAGE, "property");
    upsertMeta("twitter:card", "summary_large_image");
    upsertMeta("twitter:image", OG_IMAGE);

    upsertJsonLd("ld-org", {
      "@context": "https://schema.org",
      "@type": ["Organization", "LocalBusiness"],
      name: BUSINESS.name,
      telephone: BUSINESS.phone,
      email: BUSINESS.email,
      foundingDate: BUSINESS.established,
      address: {
        "@type": "PostalAddress",
        streetAddress: "5949 Sherry Ln #1675",
        addressLocality: "Dallas",
        addressRegion: "TX",
        postalCode: "75225",
        addressCountry: "US",
      },
      areaServed: "Dallas–Fort Worth Metroplex",
    });

    if (jsonLd) upsertJsonLd("ld-page", jsonLd);
    else {
      const el = document.getElementById("ld-page");
      if (el) el.textContent = "{}";
    }

    if (breadcrumbs) {
      upsertJsonLd("ld-breadcrumb", {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: b.item,
        })),
      });
    }
  }, [title, description, jsonLd, breadcrumbs]);

  return null;
}
